module.exports = __webpack_public_path__ + "media/images/signatures/cover-bg-2024-a86a78ee6b322a96d01511a946ef2b7c.png";